import { render, staticRenderFns } from "./cambioClave.vue?vue&type=template&id=72edfdb4"
import script from "./cambioClave.vue?vue&type=script&lang=js"
export * from "./cambioClave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports